module.exports = __webpack_public_path__ + "assets/img/GlobeTrekker_001.f94ca8cb-ps.jpg";